import { IMealLoader } from "@/services";
import { UniquePromise, ICommand } from '@/utils';
import { MealCountKey, MealCountRequest, ProgramType } from '@/models';
import { Store } from 'vuex';
import { IState } from '@/store';
import { inject, injectable } from 'inversify-props';

/** Pulls down any changes for all local meals down from the server */
@injectable()
export class SyncAllLocalMealsDownCommand implements ICommand<null> {
  @inject() private store!: Store<IState>;
  @inject() private mealLoader!: IMealLoader;

  private promise = new UniquePromise(false);

  async run() {
    return this.promise.run(async () => {
      const keys = this.getKeys();
      if (navigator.onLine && keys.length > 0) {
        const serverRequest = new MealCountRequest(keys);
        await this.mealLoader.loadServerMeals(serverRequest);
      }
    });
  }

  private getKeys() {
    let result: MealCountKey[] = [];

    const counts = this.store.state.meals.mealCountDtos;
    for (let count of counts) {
      const key = new MealCountKey(
        count.siteId,
        ProgramType[count.programId],
        count.mealTypeId,
        count.mealServiceDate,
        count.syncDateUtc);
      result.push(key);
    }

    return result;
  }
}
